import { z } from "zod/v4";

import { ExperienceDtoSchema } from "../../../../dtos/experiences";

export const PluginExperienceSchema_2024_05_05 = ExperienceDtoSchema.omit({
  variations: true,
  experienceAnalysis: true,
  isDeleted: true,
  experienceActions: true,
  userInterfaces: true,
  analyticsProducts: true,
  audience: true,
  experiencePageTargeting: true,
  experienceProducts: true,
  offerProducts: true,
  experienceCustomMetrics: true,
  experienceKeyMetrics: true,
});
export type PluginExperienceType_2024_05_05 = z.infer<
  typeof PluginExperienceSchema_2024_05_05
>;
